import { render, staticRenderFns } from "./404.vue?vue&type=template&id=65ece324&scoped=true&"
import script from "./404.vue?vue&type=script&lang=ts&"
export * from "./404.vue?vue&type=script&lang=ts&"
import style0 from "./404.vue?vue&type=style&index=0&id=65ece324&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ece324",
  null
  
)

export default component.exports